import * as Sentry from '@sentry/nextjs'

export enum LocalStorageVariables {
  cookiesAccepted = 'cookiesAccepted',
  hideUserOnboarding = 'hideUserOnboarding',
  hasSeenUserOnboarding = 'hasSeenUserOnboarding',
  hasSeenReviewRepliesOnboarding = 'hasSeenReviewRepliesOnboarding',
  hasSeenWTTOnboarding = 'hasSeenWTTOnboarding',
  hideThingtestingInfoBox = 'hideThingtestingInfoBox',
  pricingInterval = 'pricingInterval',
  returnToPath = 'returnToPath',
  signinEmail = 'signinEmail'
}

const isQuotaExceededError = (err: unknown): boolean => {
  return (
    err instanceof DOMException &&
    // everything except Firefox
    (err.code === 22 ||
      // Firefox old versions
      err.code === 1014 ||
      // everything except Firefox
      err.name === 'QuotaExceededError' ||
      // Firefox
      err.name === 'NS_ERROR_DOM_QUOTA_REACHED')
  )
}

export const isLocalStorageAvailable = () => {
  const testLabel = 'testAvailability'

  if (typeof window === 'undefined') {
    return false
  }

  try {
    localStorage.setItem(testLabel, testLabel)
    localStorage.removeItem(testLabel)
    return true
  } catch (error) {
    if (isQuotaExceededError(error)) {
      Sentry.captureException(error)
    }

    return false
  }
}

export const setLocalStorageItem = (key: string, value: string) => {
  if (isLocalStorageAvailable()) {
    localStorage.setItem(key, value)
  }
}

export const removeLocalStorageItem = (key: string) => {
  if (isLocalStorageAvailable()) {
    localStorage.removeItem(key)
  }
}

export const getLocalStorageItem = (key: string) => {
  if (isLocalStorageAvailable()) {
    return localStorage.getItem(key)
  }
}
